import React, {Children} from 'react'

import {Box, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    '& > *': {
      flex: 1,
    },
    '& > *:nth-of-type(3)': {
      justifyContent: 'flex-start',
    },
  },
}))

type ActionButtonsContainerProps = {
  children: React.ReactNode
}

const ActionButtonsContainer = ({children}: ActionButtonsContainerProps) => {
  const {classes} = useStyles()

  const cnt = Children.count(children)
  let elements

  switch (cnt) {
    case 0:
    case 3:
      elements = children
      break
    case 1:
      elements = [children]
      break
    case 2:
      elements = [...Children.toArray(children), null]
      break
  }

  // TODO : Quick and dirty fix to display one button
  return (
    <>
      {cnt !== 1 ? (
        <Box
          mt={5}
          display='flex'
          justifyContent={'center'}
          width={'100%'}
          className={classes.container}
        >
          {Children.map(elements, (child, idx) => (
            <Box key={idx} display='flex' flexGrow={1}>
              {child}
            </Box>
          ))}
        </Box>
      ) : (
        <Box mt={5}>{Children.map(elements, (child) => child)}</Box>
      )}
    </>
  )
}

export default ActionButtonsContainer
